import React from 'react';
import { useParams } from 'react-router-dom';
import { products } from '../data/mockData';

const ProductsPage = () => {
  const { category } = useParams();

  const filteredProducts = category
    ? products.filter(p => p.title.toLowerCase().includes(category.toLowerCase()))
    : products;

  return (
    <div className="pt-24 pb-16">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 via-blue-100/50 to-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Nuestros Productos
            </h1>
            <p className="text-lg text-gray-700 leading-relaxed">
              Descubre nuestra amplia gama de productos farmacéuticos de alta calidad diseñados para mejorar la salud y el bienestar de los pacientes en todo el mundo.
            </p>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProducts.map((product) => (
              <div 
                key={product.id}
                className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              >
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={product.image} 
                    alt={product.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <h3 className="absolute bottom-4 left-4 text-2xl font-bold text-white">
                    {product.title}
                  </h3>
                </div>

                {/* Content */}
                <div className="p-6">
                  <p className="text-gray-600 leading-relaxed mb-4">
                    {product.description}
                  </p>
                  <button className="text-orange-500 font-semibold hover:text-orange-600 transition-colors">
                    Más información →
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Additional Product Categories */}
          <div className="mt-16 bg-gradient-to-r from-blue-50 to-orange-50 rounded-2xl p-8 md:p-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Otras Categorías</h2>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-white p-6 rounded-xl shadow-md">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Tabletas</h3>
                <p className="text-gray-600">Formulaciones de tabletas de alta calidad para diversas indicaciones terapéuticas.</p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-md">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Cápsulas</h3>
                <p className="text-gray-600">Cápsulas de gelatina blanda y dura con tecnología avanzada.</p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-md">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Líquidos Orales</h3>
                <p className="text-gray-600">Soluciones y suspensiones orales para fácil administración.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;